import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'

export type TActualizarClave = {
  claveActual: string
  claveNueva: string
  claveNuevaConfirmacion: string
}

/**
 * Valida complejidad de contraseña localmente para evitar viajes innecesarios.
 * La expresion regular exige 2 minusculas, 2 mayusculas, 2 digitos y 2 especiales.
 */
export const schema = yup.object({
  claveActual: yup.string().trim().required('La contraseña actual es requerida'),
  claveNueva: yup
    .string()
    .trim()
    .required('La nueva contraseña es requerida')
    .matches(
      /^(?=(?:.*[a-z]){2})(?=(?:.*[A-Z]){2})(?=(?:.*\d){2})(?=(?:.*[!@#$%^&*()_+]){2})[a-zA-Z\d!@#$%^&*()_+]{8,15}$/,
      'La contraseña debe contener entre 8 y 15 caracteres, y al menos dos caracteres en minúsucla, mayúscula, númericos y especiales. Caracteres admitidos: !@#$%^&*()_+'
    ),
  claveNuevaConfirmacion: yup.string().trim().required('Por favor, confirma tu contraseña'),
})

export const useActualizarClaveForm = () => {
  return useForm<TActualizarClave>({
    mode: 'all',
    resolver: yupResolver(schema),
  })
}
